import PhoneTransferModal from './PhoneTransferModal.component';

export default PhoneTransferModal;
